export namespace StringUtil {
  export function defaultString(value: string): string {
    return value != null ? value : '';
  }

  export function compareStrings(string1: string, string2: string): number {
    if (string1 != null && string2 == null) {
      return -1;
    } else if (string1 == null && string2 != null) {
      return 1;
    } else if (string1 == null && string2 == null) {
      return 0;
    }
    return string1.localeCompare(string2);
  }

  export function compareStringsIgnoreCase(string1: string, string2: string): number {
    return this.compareStrings(string1.toLowerCase(), string2.toLowerCase());
  }

  export let ESCAPE_EXCLUDE_CHARS_REGEX: RegExp = /[\-\^\*\\\]]/g;

  export function scrubStringForFileName(value: string): string {
    return value.replace(/[^a-z0-9]/gi, '_').toLowerCase();
  }
}
